<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12">
        <v-card height="7vh" elevation="24" class="search-card">
          <v-card-text>
            <v-row>
              <v-col cols="3">
                <v-row>
                  <v-autocomplete style="z-index: 99999999 !important" :items="allZones"
                    no-data-text="اطلاعاتی وجود ندارد" dense outlined @change="readyCodeData()" clearable rounded
                    multiple clear-icon="mdi-close-circle-outline" item-text="title" item-value="id" placeholder="ناحیه"
                    v-model="searchZoneIds" autocomplete="off" prepend-inner-icon="mdi-map mdi-18px"></v-autocomplete>
                </v-row>
              </v-col>
              <v-col cols="7">
                <v-row class="mx-2">
                  <v-text-field rounded clearable dense clear-icon="mdi-close-circle-outline" outlined
                    v-on:keyup.enter="searchForAddress()" placeholder="جستجو..." @click:clear="clearSearchCode()"
                    v-model="searchAddress"></v-text-field>
                </v-row>
              </v-col>
              <v-col cols="2">
                <v-row>
                  <span class="mt-3">کد</span>
                  <v-text-field class="mr-2" rounded v-on:keyup.enter="searchForCode()" v-model="searchCode" outlined
                    clearable dense @click:clear="clearSearchCode()"
                    clear-icon="mdi-close-circle-outline"></v-text-field>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <!--map-->
      <v-col cols="12">
        <div id="map">
          <l-map v-if="isMapReadyToShow" ref="modalmap" style="height: 93vh !important" :zoom="zoom" :center="center"
            :options="mapOptions" @update:center="centerUpdate" @update:zoom="zoomUpdate" @ready="mapInvalidate()">
            <l-tile-layer :url="mapTileUrl" :attribution="attribution"></l-tile-layer>
            <!--<v-geosearch :options="geosearchOptions"></v-geosearch>-->
            <l-marker v-for="item in allMapHospitals" :key="item.id" :lat-lng="[item.lat, item.lng]"
              :icon="hospitalIcon">
              <l-tooltip :options="{
                direction: 'top',
                offset: [0, -12],
              }" class="fontFamilySET">
                بیمارستان {{ item.title }}
                <br />
                شماره: {{ item.phoneNumber }}
              </l-tooltip>
            </l-marker>
            <l-marker v-for="(item, index) in allPhonesPositions" :key="index + 'a'"
              :lat-lng="[item.latitude, item.longitude]" :icon="getMovingIcon(item)">
              <l-tooltip :options="{
                direction: 'top',
                offset: [0, -12],
                permanent: true, interactive: true
              }" class="fontFamilySET">
                کد: {{ item.phone && item.phone.code ? item.phone.code : '-' }}
                <br />
                وضعیت:
                {{ item.phone && item.phone.currentStatus ? item.phone.currentStatus : '-' }}
              </l-tooltip>
            </l-marker>
          </l-map>
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { latLng } from 'leaflet';
import L from 'leaflet';
import { LMap, LTileLayer, LMarker, LTooltip } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import CryptoJS from 'crypto-js';
import SharedMap from '@/Mixins/map';
import ShearedMixin from '@/Mixins/Shared.js';
import PhoneOnlineLocationMixin from '@/Mixins/BaseInformation/PhoneOnlineLocationMixin.js';
import ZoneMixin from '@/Mixins/BaseInformation/ZoneMixin.js';
import MapMixin from '@/Mixins/115/MapMixin';
import HospitalMixin from '@/Mixins/BaseInformation/HospitalMixin';
export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LTooltip,
  },
  mixins: [ShearedMixin, PhoneOnlineLocationMixin, ZoneMixin, MapMixin, HospitalMixin, SharedMap],
  created() { },
  mounted() {
    this.mounteLoding();
  },
  data() {
    return {
      withPopup: latLng(30.2839, 57.0834),
      withTooltip: latLng(30.2839, 57.0834),
      currentZoom: 12,
      currentCenter: latLng(30.2839, 57.0834),
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5,
        scrollWheelZoom: true,
      },
      position: [],
      dragging: false,
      icon: this.getIcon,
      mapInterval: null,
      movingIconForPhoneWithMission: require('@/assets/images/phoneWithMission.svg'),
      movingIconForPhoneWithOutMission: require('@/assets/images/phoneWithOutMission.svg'),
      movingIconForGPSWithMission: require('@/assets/images/gpsWithMission.svg'),
      movingIconForGPSWithOutMission: require('@/assets/images/gpsWithOutMission.svg'),
      stopIconForPhoneWithMission: require('@/assets/images/stopphoneWithMission.svg'),
      stopIconForPhoneWithOutMission: require('@/assets/images/stopphoneWithOutMission.svg'),
      stopIconForGPSWithMission: require('@/assets/images/stopgpsWithMission.svg'),
      stopIconForGPSWithOutMission: require('@/assets/images/stopgpsWithOutMission.svg'),
      searchZoneIds: [],
      searchAddress: '',
      searchCode: '',
      allPhonesPositions: [],
      allMapHospitals: [],
      hospitalIcon: L.icon({
        iconUrl: require('@/assets/images/hospitalMarker.svg'),
        iconSize: [22, 27],
        iconAnchor: [92, 25],
        tooltipAnchor: [10, -10],
      }),
    };
  },
  methods: {
    mounte: function () {
      L.Icon.Default.mergeOptions({
        iconRetinaUrl: require('@/assets/images/marker-icon-2x.png'),
        iconUrl: require('@/assets/images/marker-icon.png'),
        shadowUrl: require('@/assets/images/marker-shadow.png'),
      });
      this.getListOfHospitalsForOther();
      this.getAllZones();
      this.getSystemSettingByClientComputer();
      this.getAllPhoneOnlineLocationFunction();
      this.setMapBaseSystemSetting();
      this.mapInterval = setInterval(() => {
        this.getAllPhoneOnlineLocationFunction();
        let bytes = CryptoJS.AES.decrypt(localStorage.getItem('dash'), 'f9rr8Y2D96Klh87N');
        let moduleId = '';
        if (bytes.sigBytes != 0) {
          moduleId = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        } else {
          moduleId = '';
        }
        if (moduleId != 6) {
          window.close();
        }
      }, 4000);
      this.$mainSignalr.bus.$on('Location', this.fLocation);
    },
    //map
    centerUpdate(center) {
      this.currentCenter = center;
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    mapInvalidate: function () {
      setTimeout(() => {
        this.$refs.modalmap.mapObject.invalidateSize();
      }, 100);
    },
    getMovingIcon(data) {
      if (data.speed >= 2) {
        if (data.isPhoneLocation == true) {
          //is phone
          if (data.hasMission == true) {
            return L.divIcon({
              className: 'my-custom-pin',
              iconSize: [20, 20],
              iconAnchor: [80, 25],
              tooltipAnchor: [0, -10],
              html:
                '<img src="' +
                this.movingIconForPhoneWithMission +
                '" style="width:20px; height:20px; transform:rotate(' +
                data.angle +
                'deg)"/>',
            });
          } else if (data.hasMission == false) {
            return L.divIcon({
              className: 'my-custom-pin',
              iconSize: [20, 20],
              iconAnchor: [80, 25],
              tooltipAnchor: [0, -10],
              html:
                '<img src="' +
                this.movingIconForPhoneWithOutMission +
                '" style="width:20px; height:20px; transform:rotate(' +
                data.angle +
                'deg)"/>',
            });
          }
        } else if (data.isPhoneLocation == false) {
          //is gps
          if (data.hasMission == true) {
            return L.divIcon({
              className: 'my-custom-pin',
              iconSize: [20, 20],
              iconAnchor: [80, 25],
              tooltipAnchor: [0, -10],
              html:
                '<img src="' +
                this.movingIconForGPSWithMission +
                '" style="width:20px; height:20px; transform:rotate(' +
                data.angle +
                'deg)"/>',
            });
          } else if (data.hasMission == false) {
            return L.divIcon({
              className: 'my-custom-pin',
              iconSize: [20, 20],
              iconAnchor: [80, 25],
              tooltipAnchor: [0, -10],
              html:
                '<img src="' +
                this.movingIconForGPSWithOutMission +
                '" style="width:20px; height:20px; transform:rotate(' +
                data.angle +
                'deg)"/>',
            });
          }
        }
      } else if (data.speed < 2) {
        if (data.isPhoneLocation == true) {
          //is phone
          if (data.hasMission == true) {
            return L.divIcon({
              className: 'my-custom-pin',
              iconSize: [20, 20],
              iconAnchor: [80, 25],
              tooltipAnchor: [0, -10],
              html:
                '<img src="' +
                this.stopIconForPhoneWithMission +
                '" style="width:20px; height:20px; transform:rotate(' +
                0 +
                'deg)"/>',
            });
          } else if (data.hasMission == false) {
            return L.divIcon({
              className: 'my-custom-pin',
              iconSize: [20, 20],
              iconAnchor: [80, 25],
              tooltipAnchor: [0, -10],
              html:
                '<img src="' +
                this.stopIconForPhoneWithOutMission +
                '" style="width:20px; height:20px; transform:rotate(' +
                0 +
                'deg)"/>',
            });
          }
        } else if (data.isPhoneLocation == false) {
          //is gps
          if (data.hasMission == true) {
            return L.divIcon({
              className: 'my-custom-pin',
              iconSize: [20, 20],
              iconAnchor: [80, 25],
              tooltipAnchor: [0, -10],
              html:
                '<img src="' +
                this.stopIconForGPSWithMission +
                '" style="width:20px; height:20px; transform:rotate(' +
                0 +
                'deg)"/>',
            });
          } else if (data.hasMission == false) {
            return L.divIcon({
              className: 'my-custom-pin',
              iconSize: [20, 20],
              iconAnchor: [80, 25],
              tooltipAnchor: [0, -10],
              html:
                '<img src="' +
                this.stopIconForGPSWithOutMission +
                '" style="width:20px; height:20px; transform:rotate(' +
                0 +
                'deg)"/>',
            });
          }
        }
      }
    },
    readyCodeData: function () {
      this.allPhonesPositions = [];
      if (this.searchZoneIds.length > 0) {
        for (let i = 0; i < this.searchZoneIds.length; i++) {
          for (let j = 0; j < this.allPhoneOnlineLocations.length; j++) {
            if (this.searchZoneIds[i] == this.allPhoneOnlineLocations[j].phone.zoneId) {
              this.allPhonesPositions.push(this.allPhoneOnlineLocations[j]);
            }
          }
        }
      } else {
        this.allPhonesPositions = this.allPhoneOnlineLocations;
      }
    },
    searchForCode: function () {
      if (this.searchCode) {
        let searchObject = this.allPhoneOnlineLocations.find(
          (c) => c.phone.code == this.searchCode,
        );
        this.$refs.modalmap.mapObject.flyTo([searchObject.latitude, searchObject.longitude], 16);
      } else {
        this.clearSearchCode();
      }
    },

    readyMapHopitalLocations: function () {
      this.allMapHospitals = [];
      for (let i = 0; i < this.allHospitalsForOther.length; i++) {
        if (this.allHospitalsForOther[i].latitude) {
          this.allMapHospitals.push({
            lat: this.allHospitalsForOther[i].latitude,
            lng: this.allHospitalsForOther[i].longitude,
            title: this.allHospitalsForOther[i].title,
            id: this.allHospitalsForOther[i].id,
            phoneNumber: this.allHospitalsForOther[i].phoneNumber
              ? this.allHospitalsForOther[i].phoneNumber
              : '-',
          });
        }
      }
    },
    clearSearchCode: function () {
      const lat = this.$store.state.SystemSettingModule.systemSetting?.mapCenterLatitude;
      const lng = this.$store.state.SystemSettingModule.systemSetting?.mapCenterLongitude;
      const zoom = this.$store.state.SystemSettingModule.systemSetting?.mapDefaultZoomLevel;
      if (lat && lng) {
        this.$refs.modalmap.mapObject.flyTo([lat, lng], zoom ?? 12);
      }
    },
    searchForAddress: function () {
      if (this.searchAddress) {
        this.getMapGeoCode(this.searchAddress);
      } else {
        this.clearSearchCode();
      }
    },
    goToAddress: function (data) {
      this.$refs.modalmap.mapObject.flyTo([data.longitude, data.latitude], 15);
    },
    fLocation(data) {
      if (this.$store.state.userModule.userId == data?.data?.userId) {
        for (const item of this.allPhonesPositions) {
          if (data?.data?.code == item.phone.code) {
            this.$refs.modalmap.mapObject.flyTo([item.latitude, item.longitude], 17);
          }
        }
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.mapInterval);
    this.$mainSignalr.bus.$off('Location', this.fLocation);
  },
};
</script>
<style scoped>
.search-card {
  background: var(--background-color) !important;
  border-radius: 0px !important;
}

>>>.leaflet-tooltip {
  opacity: 0.6 !important;
}
</style>
